import { generateLeadEvent, customEvent, trackPageView } from '../../../modules/tracking/AnalyticsEvents';
import ContactFormValidator from '../../../validation/ContactFormValidator';

export default async function(codeweaversResponse, customerParameters, vehicle) {
    const key = codeweaversResponse.financeKeyObject.pseudoKey;
    const quote = codeweaversResponse.getFinanceProductOfInterest(codeweaversResponse.financeKeyObject);
    const quoteForEmail = codeweaversResponse.financeKeyObject.getQuoteTitleValuePairs(quote);

    const locationData = await window.LocationDataLoader.get();
    let filteredLocations = locationData.slice(0);

    if (typeof filterDealers !== 'undefined') {
        filteredLocations = filteredLocations.filter(function (location) {
            if (typeof filterDealers[location.id] !== 'undefined') {
                return true;
            }
            return false;
        });
    }

    $.ajax({
        url: "/"+brand+"/new/finance-enquire-now",
        financeKeyObject: codeweaversResponse.financeKeyObject,
        vehicle: vehicle,
        quote: quote,
        quoteForEmail: quoteForEmail,
        customerParameters: customerParameters,
        type: "GET",
        cache: false,
        data: {},
        dataType: "html",
        success: function(response) {
            $('[data-remodal-id=modal]').html(response);
            const financeKeyObject = this.financeKeyObject;
            const vehicle = this.vehicle;
            const quote = this.quote;
            const quoteForEmail = this.quoteForEmail;
            const customerParameters = this.customerParameters;
            const form = document.getElementById('make-an-enquiry-form');

            customEvent('New Vehicle', 'Enquire about finance', financeKeyObject.longName);

            inst.open();

            const financeEnquiryFormValidator = new ContactFormValidator({
                element: form
            });

            const locationHandler = new CustomerLocationHandler();
            locationHandler.setLocationData(filteredLocations);
            locationHandler.setup('make-an-enquiry-form');

            $(form).on('submit', async function() {
                if (!await financeEnquiryFormValidator.isValid()) {
                    return false;
                }
                const formData = $(this).serializeArray();
                formData.push({
                    name:'finance-type',
                    value: financeKeyObject.longName
                });
                formData.push({
                    name:'vehicle',
                    value: vehicle.id
                });
                formData.push({
                    name:'quote-details',
                    value: JSON.stringify(quote)
                });
                formData.push({
                    name:'quote-data-for-email',
                    value: JSON.stringify(quoteForEmail)
                });
                formData.push({
                    name:'customer-request',
                    value: JSON.stringify(financeKeyObject.getRelevantCustomerParameters(customerParameters))
                });
                financeEnquiryFormValidator.preventInput();
                $.ajax({
                    longFinanceName: financeKeyObject.longName,
                    type: "POST",
                    cache: false,
                    dataType: 'json',
                    url: form.getAttribute('action'),
                    data: formData,
                    success: function(response) {
                        customEvent('New Vehicle', 'Enquire about finance - ' + this.longFinanceName, 'Complete');
                        trackPageView('/conversion/new-vehicle-enquire-about-finance/complete', 'New Vehicle - Enquire about finance Completed');
                        generateLeadEvent('new_finance_enquiry');

                        if (typeof response.name !== 'undefined') {
                            $('#make-an-enquiry-form').html(`
                                <h2>Thank you for your enquiry</h2>
                                <p>Your enquiry has been sent to ${response.name}.</p>
                                <p>Someone will be in touch soon to discuss your enquiry</p>`);
                        }
                        else {
                            $('#make-an-enquiry-form').html(`
                                <h2>Thank you for your enquiry</h2>
                                <p>Your enquiry has been sent to your chosen dealer.</p>
                                <p>Someone will be in touch soon to discuss your enquiry</p>`);
                        }

                        financeEnquiryFormValidator.allowInput();
                    },
                    error: function(response) {
                        outputErrorToForm('make-an-enquiry-form', parseErrorResponse(response));
                        financeEnquiryFormValidator.allowInput();
                    }
                });
                return false;
            });
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance-enquiry-form.js